import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useCompanySelection } from "../context/CompanySelectionContext";
import { LoadingSpinner } from "../Components/LoadingSpinner";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const { loading: companyLoading } = useCompanySelection();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (companyLoading) {
    return <LoadingSpinner />;
  }

  return children;
};

export default ProtectedRoute;
